export const GET_TRAINING_WORKING_SLOTS_REQUEST =
  "GET_TRAINING_WORKING_SLOTS_REQUEST";
export const GET_TRAINING_WORKING_SLOTS_RESPONSE =
  "GET_TRAINING_WORKING_SLOTS_RESPONSE";
export const ADD_TRAINING_WORKING_SLOT = "ADD_TRAINING_WORKING_SLOT";
export const EDIT_TRAINING_WORKING_SLOT_REQUEST =
  "EDIT_TRAINING_WORKING_SLOT_REQUEST";
export const DELETE_TRAINING_WORKING_SLOT_REQUEST =
  "DELETE_TRAINING_WORKING_SLOT_REQUEST";
